// Copyright (c) 2016 Deere & Company

import WarrantyExpiration from './components/warranty-expiration';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {mapBoundActionCreatorsToActionsProp} from '../../../src/shared/services/state-connector';

const getStateToBindToContainerProps = state => ({
    ...state.reports.warrantyExpiration,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    selectedLayout: state.reportVariant.selectedLayout
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(WarrantyExpiration);




// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state-connector.js